import { useParams } from 'react-router-dom';

import * as Components from 'view-layer/components';

import useFetch, { FetchResult } from 'data-layer/fetch-api/useFetch';
import { PaymentRequestService } from 'data-layer/services/PaymentRequestService';
import { PaymentDataDto } from 'data-layer/dto';
import { useDocumentTitle } from 'business-layer/hooks/useDocumentTitle';

import React from 'react';
import { LayoutContainer } from 'view-layer/components/layout/LayoutContainer';
import { PendingPaymentForOxxo } from 'view-layer/components/layout/statuses/PaymentPendingForOxxo';
import { PaymentPendingFor3dsCard } from 'view-layer/components/layout/statuses/PaymentPendingFor3dsCard';
import { CardPaymentProcessing } from 'view-layer/components/layout/statuses/CardPaymentProcessing';
import { PaymentPendingGeneric } from 'view-layer/components/layout/statuses/PaymentPendingGeneric';

export const Pending = (props: any) => {
  useDocumentTitle('Payment Pending');
  const { hash = '' } = useParams();

  const [ data, loading, error ]: FetchResult<PaymentDataDto> = useFetch(PaymentRequestService(hash), PaymentDataDto, hash);

  const isOxxoPayment = React.useMemo(() => data?.payment?.nextAction?.type === 'oxxo_voucher', [data?.payment?.nextAction?.type]);
  const isRedirectPayment = React.useMemo(() => data?.payment?.nextAction?.type === 'redirect', [data?.payment?.nextAction?.type]);
  const isConfirmationPending = React.useMemo(() => data?.payment?.nextAction?.type === 'stripe_confirmation_details', [data?.payment?.nextAction?.type]);


  React.useEffect(() => {
    if (isRedirectPayment && data?.payment?.nextAction?.details?.url) {
      window.location.replace(data?.payment.nextAction.details.url);
    }
  }, [isRedirectPayment, data?.payment?.nextAction?.details?.url])


  if (loading) {
    return (
      <Components.Common.Loader />
    );
  }
  if (data === null) {
    return <></>;
  }
  if (data?.payment?.reservationId === null) {
    return <Components.Layout.MessagePanel message={'We are sorry, but we can\'t find your payment details.'} />;
  }
  if (!!error) {
    return <Components.Layout.MessagePanel message={error} />;
  }

  if (isRedirectPayment && data?.payment?.nextAction?.details?.url) {
    return <Components.Common.Loader />;
  }

  return (
    <LayoutContainer payment={{ ...data?.payment, ...data?.property}}>
      { isOxxoPayment
        ? <PendingPaymentForOxxo nextAction={data?.payment.nextAction} />
        : isRedirectPayment
          ? <CardPaymentProcessing />
          : isConfirmationPending
            ? <PaymentPendingGeneric />
            : <PaymentPendingFor3dsCard />
      }
    </LayoutContainer>
  )
}
